/**
 * Pub/sub bridge for live `task.comment.created` WebSocket events.
 *
 * The owner connection's WebSocket client is the single consumer of the
 * browser WS stream. When a new comment arrives, its frame reducer calls
 * `publishTaskComment`, which fans the payload out to any currently
 * mounted listeners (e.g. `CommentPopover`) registered via
 * `subscribeToTaskComments`.
 *
 * Mirrors the shape of `task-refine-bus.ts` — no broadcast replay,
 * listeners only see events fired while they are subscribed.
 */

import type { TaskComment } from "@/api/tasks";

export interface TaskCommentCreatedEvent {
  task_id: string;
  comment: TaskComment;
}

type Listener = (event: TaskCommentCreatedEvent) => void;

const listeners = new Set<Listener>();

export function subscribeToTaskComments(cb: Listener): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function publishTaskComment(event: TaskCommentCreatedEvent): void {
  for (const cb of listeners) {
    try {
      cb(event);
    } catch {
      // A single listener must not break fan-out to the others.
    }
  }
}
